
const initialState = {
  downloadId: undefined,
  loading: false,
  success: false,
  error: false,
};

export const downloadRequest = (namespace) => (state = initialState, action) => {
  switch (action.type) {
    case `${namespace}/DOWNLOAD_REQUEST_REQUEST`: {
      return { ...initialState, downloadId: action.downloadId, loading: true };
    }
    case `${namespace}/DOWNLOAD_REQUEST_SUCCESS`: {
      return { ...state, downloadId: undefined, success: false, loading: false };
    }
    case `${namespace}/DOWNLOAD_REQUEST_FAILURE`: {
      return { ...state, downloadId: undefined, success: false, error: action.error, loading: false };
    }
    default:
      return state;
  }
};
